import { getEnquiryFormGoalsEndpoint } from '@cont/OfflineCentres/apiHelper';
import useFetch from '@hooks/useFetch';

const useOfflineGoalData = () => {
  const {
    data: offlineGoals,
    isLoading: isGoalDataLoading,
    ...rest
  } = useFetch(getEnquiryFormGoalsEndpoint(), { useCamelCase: false });
  return { offlineGoals, isGoalDataLoading, ...rest };
};

export default useOfflineGoalData;
